export default __webpack_public_path__ + "static/home-page-9c9c0107ca65901ac67f31cd7b3e459b.png";